import { render, staticRenderFns } from "./FormSanciones.vue?vue&type=template&id=c1fb0cbc"
import script from "./FormSanciones.vue?vue&type=script&lang=js"
export * from "./FormSanciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports